import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '@app/material/material.module';

import { SortSelectorComponent } from './sort-selector.component';

@NgModule({
  declarations: [SortSelectorComponent],
  imports: [CommonModule, MaterialModule],
  exports: [SortSelectorComponent]
})
export class SortSelectorModule {}
